@if (visible()) {
    <div
        class="flex w-full flex-0 flex-col overflow-hidden border-b-2 print:hidden"
        [ngClass]="phaseStyle().container"
    >
        <div class="flex items-center gap-x-2.5 px-4 py-2 md:px-6">
            <mat-icon
                class="!h-5 !w-5 flex-shrink-0 !text-xl !leading-5"
                [ngClass]="phaseStyle().accent"
            >
                {{ phaseStyle().icon }}
            </mat-icon>

            <p class="flex-1 text-sm leading-snug" [ngClass]="phaseStyle().text">
                <span class="font-semibold">{{ phaseStyle().title }}</span>
                <span class="hidden sm:inline">{{ phaseStyle().lead }}</span>
                <span class="sm:hidden">&nbsp;</span>
                <span
                    class="font-semibold tabular-nums"
                    [ngClass]="phaseStyle().accent"
                >
                    {{ formattedTime() }}
                </span>
                <span class="sm:hidden">
                    restante
                    @if (paused()) {
                        (pausado)
                    }
                </span>
                @if (paused()) {
                    <span class="hidden sm:inline"> · pausado</span>
                }
            </p>

            <button
                mat-stroked-button
                class="flex-shrink-0 whitespace-nowrap"
                [ngClass]="phaseStyle().button"
                (click)="update()"
            >
                <mat-icon
                    class="mr-1 !h-4 !w-4 !text-base !leading-4"
                    [ngClass]="phaseStyle().accent"
                >
                    logout
                </mat-icon>
                <span class="hidden sm:inline">Actualizar y salir</span>
                <span class="sm:hidden">Actualizar</span>
            </button>
        </div>

        <div
            class="h-0.5 transition-all duration-1000 ease-linear"
            [ngClass]="phaseStyle().progress"
            [style.width.%]="progressPct()"
        ></div>
    </div>
}
